import { SystemAudioSettings } from "@/components/blocks/system-audio-settings/system-audio-settings";

const SystemAudioSettingsDemo = () => (
  <SystemAudioSettings class="w-full max-w-md" />
);

export default SystemAudioSettingsDemo;
